import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from "../../../../environments/environment";
import { CmsService } from 'src/app/Services/cms.service';
import { ActivatedRoute, Router } from '@angular/router';

declare var bootstrap: any;

@Component({
  selector: 'app-tarifarios',
  templateUrl: './tarifarios.component.html',
  standalone: false
})
export class TarifariosComponent implements OnInit, AfterViewInit {

  // ---CMS---
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;
  fares_content: string = 'linhas-tarifario';
  faresInfo: any = {};

  fares_list_content: string = 'linhas-lista-tarifarios'
  faresList: any[] = [];
  faresListReady: boolean = false;

  constructor(
    private cmsService: CmsService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private title: Title
  ) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['tarifarios']
      this.title.setTitle(pageTitle);
    })
  }

  ngOnInit(): void {
    this.getContent();
    this.getFaresList();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.route.fragment.subscribe(fragment => {
        if (fragment) {
          const tabElement = document.getElementById(fragment);
          if (tabElement) {
            const tab = new bootstrap.Tab(tabElement);
            tab.show();
          }
        }
      });
    }, 500);
  }

  getContent(){
    this.cmsService.getContentList(this.fares_content, this.language).subscribe(
      {
        next: data => {
          this.faresInfo = data['body']['data'];
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getFaresList(){
    this.cmsService.getContentList(this.fares_list_content, this.language).subscribe(
      {
        next: data => {
          this.faresList = data['body']['data'];

          this.faresList.sort((a,b) => (a.Ordem > b.Ordem) ? 1 : -1 );

          this.faresListReady = true;

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }
}
